
  import React from "react"
  import Component from "/opt/buildhome/repo/src/layouts/index.js"
  import data from "/opt/buildhome/repo/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js